import styles from '../../styles.module.scss';
import { ArrayInput } from "../ArrayInput";
import { DetailsInput } from "../DetailsInput";
import { TDefaultListValue } from "api/http-client/types";
import { DateInput, TFields, TFieldsDate } from '../../model';
import { useAppSelector } from 'hooks';
import { CustomDateInput } from '../CustomDateInput';
import { useTranslates } from 'providers/translates';

type Props = {
  forces: TDefaultListValue[];
  units: TDefaultListValue[];
  troops: TDefaultListValue[];
  divisions: TDefaultListValue[];
  regiments: TDefaultListValue[];
  detachmentsSectionsUnits: TDefaultListValue[];
  toursOfDuty: TDefaultListValue[];
  postings: TDefaultListValue[];
  awardsAndHonors: TDefaultListValue[];
  enlistmentDate: DateInput;
  setForces: React.Dispatch<React.SetStateAction<TDefaultListValue[]>>;
  setUnits: React.Dispatch<React.SetStateAction<TDefaultListValue[]>>;
  setTroops: React.Dispatch<React.SetStateAction<TDefaultListValue[]>>;
  setDivisions: React.Dispatch<React.SetStateAction<TDefaultListValue[]>>;
  setRegiments: React.Dispatch<React.SetStateAction<TDefaultListValue[]>>;
  setDetachment: React.Dispatch<React.SetStateAction<TDefaultListValue[]>>;
  setToursOfDuty: React.Dispatch<React.SetStateAction<TDefaultListValue[]>>;
  setPostings: React.Dispatch<React.SetStateAction<TDefaultListValue[]>>;
  setAwardsAndHonors: React.Dispatch<React.SetStateAction<TDefaultListValue[]>>;
  setValueToEditableQuilt: (key: TFields, value: string) => void; 
  handleSetDay: (nameDate: TFieldsDate, date: Date | null) => void;
  handleSetMonth: (nameDate: TFieldsDate, date: Date | string | null) => void;
  handleSetYear: (nameDate: TFieldsDate, date: Date | null) => void;
}

export const ServiceInformation: React.FC<Props> = ({
  forces,
  units,
  troops,
  divisions,
  regiments,
  detachmentsSectionsUnits,
  toursOfDuty,
  postings,
  awardsAndHonors,
  enlistmentDate,
  setForces,
  setUnits,
  setTroops,
  setDivisions,
  setRegiments,
  setDetachment,
  setToursOfDuty,
  setPostings,
  setAwardsAndHonors,
  setValueToEditableQuilt,
  handleSetDay,
  handleSetMonth,
  handleSetYear
}) => {
  const { translates } = useTranslates();
  const serviceInformationFieldsSection = translates?.quiltBuilderStepOne?.serviceInformationFieldsSection;

  const editableQuiltStore = useAppSelector((state) => state.quilt.editableQuilt);
  
  return (
    <div style={{display: 'flex', flexDirection: 'column', flexGrow: '1'}}>
      <span className={styles.details__title}>{serviceInformationFieldsSection?.serviceInformationHeading ?? 'Service Information'}</span>
      <div className={styles.details__inputs}>
        <div className={styles.details__columnInput}>
          <ArrayInput 
            title={serviceInformationFieldsSection?.forceFieldLabel ?? "Force"}
            items={forces}
            onSetState={setForces}
            placeholder={serviceInformationFieldsSection?.forceFieldDefaultStateText}
          />
          <DetailsInput
            title={serviceInformationFieldsSection?.serviceNumberFieldLabel ?? "Service Number"}
            value={editableQuiltStore?.serviceNumber}
            onChange={({target}) => {
              setValueToEditableQuilt('serviceNumber', target.value);
            }}
            placeholder={serviceInformationFieldsSection?.serviceNumberFieldDefaultStateText}
          />
          <DetailsInput
            title={serviceInformationFieldsSection?.regimentalNumberFieldLabel ?? "Regimental Number"}
            value={editableQuiltStore?.regimentalNumber}
            onChange={({target}) => {
              setValueToEditableQuilt('regimentalNumber', target.value);
            }}
            placeholder={serviceInformationFieldsSection?.regimentalNumberFieldDefaultStateText}
          />
          <ArrayInput 
            title={serviceInformationFieldsSection?.unitFieldLabel ?? "Unit"}
            items={units}
            onSetState={setUnits}
            placeholder={serviceInformationFieldsSection?.unitFieldDefaultStateText}
          />
          <ArrayInput 
            title={serviceInformationFieldsSection?.troopFieldLabel ?? "Troop"}
            items={troops}
            onSetState={setTroops}
            placeholder={serviceInformationFieldsSection?.troopFieldDefaultStateText}
          />
          <CustomDateInput
            title={serviceInformationFieldsSection?.enlistmentDateFieldLabel ?? "Enlistment Date"}
            dateInput={enlistmentDate}
            onChangeDay={(date) => handleSetDay('enlistmentDate', date)}
            onChangeMonth={(date) => handleSetMonth('enlistmentDate', date)}
            onChangeYear={(date) => handleSetYear('enlistmentDate', date)}
          />
        </div>
        <div className={styles.details__columnInput}>
          <ArrayInput 
            title={serviceInformationFieldsSection?.divisionFieldLabel ?? "Division"}
            items={divisions}
            onSetState={setDivisions}
            placeholder={serviceInformationFieldsSection?.divisionFieldDefaultStateText}
          />
          <ArrayInput 
            title={serviceInformationFieldsSection?.regimentFieldLabel ?? "Regiment"}
            items={regiments}
            onSetState={setRegiments}
            placeholder={serviceInformationFieldsSection?.regimentFieldDefaultStateText}
          />
          <ArrayInput 
            title={serviceInformationFieldsSection?.detachmentFieldLabel ?? "Detachment/Section/Unit"}
            items={detachmentsSectionsUnits}
            onSetState={setDetachment}
            placeholder={serviceInformationFieldsSection?.detachmentfFieldDefaultStateText}
          />
          <ArrayInput 
            title={serviceInformationFieldsSection?.toursFieldLabel ?? "Tours of duty"}
            items={toursOfDuty}
            onSetState={setToursOfDuty}
            placeholder={serviceInformationFieldsSection?.toursFieldDefaultStateText}
          />
          <ArrayInput 
            title={serviceInformationFieldsSection?.postingsFieldLabel ?? "Posting"}
            items={postings}
            onSetState={setPostings}
            placeholder={serviceInformationFieldsSection?.postingsFieldDefaultStateText}
          />
          <ArrayInput 
            title={serviceInformationFieldsSection?.awardsFieldLabel ?? "Awards and Honors"}
            items={awardsAndHonors}
            onSetState={setAwardsAndHonors}
            placeholder={serviceInformationFieldsSection?.awardsFieldDefaultStateText}
          />
        </div>
      </div>
    </div>
  );
};
